// put some must have constants here need to be bundled in loader to reduce size
export const MICRO_APP_NAME = 'cloud-mgmt'
export const MSP_MICRO_APP = 'sase-msp'

export const ASC_TIER_1_SUPPORT_ROLE = 'tier_1_support'

export const MSP_URL = '/msp'

export const STATE_READY_EVENT_NAME = 'common-module-state-ready'
